import { ReactComponent as LeftArrow } from '../../assets/directory/leftArrow.svg'
import { ReactComponent as RightArrow } from '../../assets/directory/rightArrow.svg'
import { ReactComponent as UpArrow } from '../../assets/directory/UpArrow.svg'
import { ReactComponent as DownArrow } from '../../assets/directory/DownArrow.svg'
import { ReactComponent as Cancel } from '../../assets/Cancel.svg'
import { ReactComponent as Cross } from '../../assets/cross.svg'
import { ReactComponent as GreenBackgroundCancelCross} from '../../assets/Icons/cross.svg'
import { ReactComponent as FiltersIcon } from '../../assets/Icons/newsfeed icons/Filters.svg'
import { ReactComponent as FiltersIcon2 } from '../../assets/Icons/newsfeed icons/More filters.svg'
import { ReactComponent as CalendarIcon } from '../../assets/Icons/newsfeed icons/Date range.svg'
import { ReactComponent as GreyArrowDown } from '../../assets/GreyArrowDown.svg'
import { ReactComponent as ContinueArrow } from '../../assets/ContinueArrow.svg'
import { ReactComponent as CommentIcon } from '../../assets/Icons/post icons/comments.svg'
import { ReactComponent as ShareIcon } from '../../assets/Icons/post icons/share.svg'
import { ReactComponent as ShareIcon2 } from '../../assets/share.svg'
import { ReactComponent as SaveIcon } from '../../assets/Icons/save.svg'
import { ReactComponent as CRM } from '../../assets/Icons/post icons/crm.svg'
import { ReactComponent as View } from '../../assets/Icons/post icons/view.svg'
import { ReactComponent as Review } from '../../assets/Icons/post icons/review.svg'
import { ReactComponent as Reviewed } from '../../assets/Icons/post icons/review filled.svg'
import { ReactComponent as Flag } from '../../assets/flag.svg'
import { ReactComponent as FlagGreyFill } from '../../assets/Icons/post icons/flagGreyFill.svg'
import { ReactComponent as GreenDot } from '../../assets/GreenDot.svg'
import { ReactComponent as Download } from '../../assets/Icons/newsfeed icons/download.svg'
import { ReactComponent as LinkedIN } from '../../assets/Icons/LinkedinIcon.svg'
import { ReactComponent as Info } from '../../assets/Info.svg'
import { ReactComponent as ProgressingDownload } from '../../assets/Icons/ProgressingDownload.svg'
import { ReactComponent as SearchLens } from '../../assets/search.svg'
import { ReactComponent as SearchLensSad } from '../../assets/SearchLensSad.svg'
import { ReactComponent as SearchLensDark } from '../../assets/searchLensDark.svg'
import { ReactComponent as GreenSearchLens } from '../../assets/GreenSearchLens.svg'
import { ReactComponent as SelectAll } from '../../assets/directory/selectAll.svg'
import { ReactComponent as UnselectAll } from '../../assets/directory/unselectAll.svg'
import { ReactComponent as Exit } from '../../assets/exit.svg'
import { ReactComponent as NoExport } from '../../assets/Icons/no exports.svg'
import { ReactComponent as Show } from '../../assets/Icons/Show.svg'
import { ReactComponent as Hide } from '../../assets/Icons/Hide.svg'
import { ReactComponent as NotFound } from '../../assets/Icons/error_icons/NotFoundError.svg'
import { ReactComponent as GreyNotFound } from '../../assets/Icons/error_icons/GreyNotFoundError.svg'
import { ReactComponent as RedFail } from '../../assets/Icons/Fail.svg'
import { ReactComponent as SuccessGreen } from '../../assets/Icons/Success.svg'
import { ReactComponent as AiStar1 } from '../../assets/reports/AiStar1.svg'
import { ReactComponent as AiStar2 } from '../../assets/reports/AiStar2.svg'
import { ReactComponent as AiStar3 } from '../../assets/reports/AiStar3.svg'
import { ReactComponent as Stars } from '../../assets/reports/stars.svg'
import { ReactComponent as GreenArrowCircleRight } from '../../assets/reports/Arrow circle right.svg'
import { ReactComponent as CircleLeftArrow } from '../../assets/reports/CircleLeftArrow.svg'
import { ReactComponent as CircleRightArrow } from '../../assets/reports/CircleRightArrow.svg'
import { ReactComponent as DarkDropDown } from '../../assets/darkDropdown.svg'
import { ReactComponent as Copy } from '../../assets/reports/Copy.svg'
import { ReactComponent as External_Link } from '../../assets/External_Link.svg'
import { ReactComponent as EditPencil } from '../../assets/EditPencil.svg'
import { ReactComponent as MenuDots } from '../../assets/MenuDots.svg'
import { ReactComponent as GreenTick } from '../../assets/new_one.svg'
import { ReactComponent as SuccessGrey } from '../../assets/Icons/check_circle_grey.svg'
import { ReactComponent as TimeSolid } from '../../assets/Icons/Time_solid.svg'
import { ReactComponent as SortIcon } from '../../assets/SortIcon.svg'
import { ReactComponent as CircularStar } from '../../assets/reports/CircularStar.svg'
import { ReactComponent as fileChartColumn } from '../../assets/reports/file-chart-column.svg'
import { ReactComponent as EditGreenPencil } from '../../assets/editGreenPencil.svg'
import { ReactComponent as WarningExclamation } from '../../assets/WarningExclamation.svg'
import { ReactComponent as GreenUp } from '../../assets/GreenUpArrow.svg'
import { ReactComponent as GreenDown } from '../../assets/GreenDownArrow.svg'
import { ReactComponent as LightGreyDownV } from '../../assets/Icons/LightGreyDownV.svg'
import { ReactComponent as BlackMenuDots } from '../../assets/directory/black_menu_dot.svg'
import { ReactComponent as SearchIcon } from '../../assets/search.svg'
import { ReactComponent as ViewColumn } from '../../assets/Icons/view_column.svg'
import { ReactComponent as GreenDownV } from '../../assets/Icons/green_down_v.svg'
import { ReactComponent as GreyDownV } from '../../assets/Icons/GrayDownV.svg'
import { ReactComponent as GreyMenuDots } from '../../assets/Icons/GreyMenuDots.svg'
import { ReactComponent as GreyRightArrow } from '../../assets/Icons/GreyRightArrow.svg'
import { ReactComponent as BoldEyeHide } from '../../assets/Icons/bold_hide.svg'
import { ReactComponent as BoldEyeShow } from '../../assets/Icons/bold_show.svg'
import { ReactComponent as EmptyProfileCard } from '../../assets/Icons/empty_profile_card.svg'
import { ReactComponent as FillProfileCard } from '../../assets/Icons/fill_profile_card.svg'
import { ReactComponent as UserPic } from '../../assets/Icons/UserAttributes.svg'
import { ReactComponent as DeleteBin } from '../../assets/deleteBin.svg'
import { ReactComponent as Delete } from '../../assets/Icons/Delete.svg'
import { ReactComponent as AddPlusCircle } from '../../assets/Add_Plus_Circle.svg'
import { ReactComponent as DeleteBin2 } from '../../assets/Icons/deleteBin2.svg'
import { ReactComponent as helpIcon } from '../../assets/Icons/helpIcon.svg'
import { ReactComponent as darkHelpIcon } from '../../assets/Icons/darkHelpIcon.svg'
import { ReactComponent as resetIcon } from '../../assets/Icons/resetIcon.svg'
import { ReactComponent as Success_tick } from '../../assets/Success_tick.svg'
import { ReactComponent as Guideline} from '../../assets/Icons/guideline.svg'

import { ReactComponent as WindfallLogo } from '../../assets/Icons/windfall_logo.svg'
import { Suspense } from 'react'
const iconMap = {
  LeftArrow: LeftArrow,
  RightArrow: RightArrow,
  UpArrow: UpArrow,
  DownArrow: DownArrow,
  Cancel: Cancel,
  Cross: Cross,
  GreenBackgroundCancelCross: GreenBackgroundCancelCross,
  FiltersIcon: FiltersIcon,
  CalendarIcon: CalendarIcon,
  FiltersIcon2: FiltersIcon2,
  GreyArrowDown: GreyArrowDown,
  ContinueArrow: ContinueArrow,
  LightGreyDownV: LightGreyDownV,
  GreenDownV: GreenDownV,
  GreyDownV: GreyDownV, //TODO - replace old GreyArrowDown to GreyDownV
  GreyMenuDots: GreyMenuDots, //TODO - replace old MenuDots to GreyMenuDots
  CommentIcon: CommentIcon,
  ShareIcon: ShareIcon,
  ShareIcon2: ShareIcon2,
  SaveIcon: SaveIcon,
  CRM: CRM,
  View: View,
  Review: Review,
  Reviewed: Reviewed,
  Flag: Flag,
  FlagGreyFill: FlagGreyFill,
  GreenDot: GreenDot,
  Download: Download,
  LinkedIN: LinkedIN,
  Info: Info,
  ProgressingDownload: ProgressingDownload,
  SearchLens: SearchLens,
  SearchLensSad: SearchLensSad,
  SearchLensDark: SearchLensDark,
  GreenSearchLens: GreenSearchLens,
  SelectAll: SelectAll,
  UnselectAll: UnselectAll,
  Exit: Exit,
  NoExport: NoExport,
  Show: Show,
  Hide: Hide,
  NotFound: NotFound,
  GreyNotFound: GreyNotFound,
  RedFail: RedFail,
  SuccessGreen: SuccessGreen,
  AiStar1: AiStar1,
  AiStar2: AiStar2,
  AiStar3: AiStar3,
  Stars: Stars,
  GreenArrowCircleRight: GreenArrowCircleRight,
  CircleLeftArrow: CircleLeftArrow,
  CircleRightArrow: CircleRightArrow,
  DarkDropDown: DarkDropDown,
  Copy: Copy,
  External_Link: External_Link,
  EditPencil: EditPencil,
  MenuDots: MenuDots,
  GreenTick: GreenTick,
  SuccessGrey: SuccessGrey,
  TimeSolid: TimeSolid,
  SortIcon: SortIcon,
  CircularStar: CircularStar,
  fileChartColumn: fileChartColumn,
  EditGreenPencil: EditGreenPencil,
  GreyRightArrow: GreyRightArrow,
  WarningExclamation: WarningExclamation,
  GreenDown: GreenDown,
  GreenUp: GreenUp,
  BlackMenuDots: BlackMenuDots,
  SearchIcon: SearchIcon,
  ViewColumn: ViewColumn,
  BoldEyeHide: BoldEyeHide,
  BoldEyeShow: BoldEyeShow,
  EmptyProfileCard: EmptyProfileCard,
  FillProfileCard: FillProfileCard,
  UserPic: UserPic,
  DeleteBin: DeleteBin,
  Delete: Delete,
  AddPlusCircle: AddPlusCircle,
  DeleteBin2: DeleteBin2,
  helpIcon: helpIcon,
  darkHelpIcon: darkHelpIcon,
  resetIcon: resetIcon,
  Success_tick: Success_tick,
  Guideline: Guideline,
  WindfallLogo: WindfallLogo
};

const Icon = ({ name, ...props }) => {
  const IconComponent = iconMap[name];

  if (!IconComponent) {
    console.error(`No icon found for name: ${name}`);
    return null;
  }

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <IconComponent {...props} alt={name} />
    </Suspense>
  );
};

export default Icon;
